// extracted by mini-css-extract-plugin
export default {"container":"NavbarPlaceholder_container__-t2GA"};